

jQuery(document).ready(function ($) {
  "use strict";

  function initSidebar() {
    $('.sidebar-template[data-content]').each(function () {
      var key = $(this).data('content');
      var $target = $('#sidebar-section[data-content="' + key + '"] ');
      var $src = $(this);
      if ($target.length && $src.length) {
        $target.empty().append($src.children());
        $src.remove();
      }
    });
  }
  function handleSidebarCanvas() {
    const $sidebar = $('.canvas-sidebar');
    const $overlay = $('.overlay-canvas');
    $('.btn-sidebar').on('click', function () {
      $sidebar.addClass('show');
      $overlay.addClass('show');
    });
    $('.icon-close-sb, .overlay-canvas').on('click', function () {
      $sidebar.removeClass('show');
      $overlay.removeClass('show');
    });
  };
  $(function () {
    initSidebar();
    handleSidebarCanvas();
  });

  document.addEventListener('shopify:section:load', function () {
    initSidebar();
    handleSidebarCanvas();
  });

})




